const menuPl = {
    'menu.title': 'Fantasy Kingdom',
    'menu.startSandbox': 'Start sandbox',
    'menu.tutorials': 'Samouczki',
    'menu.pickTutorial': 'Wybierz samouczek',
    'menu.back': 'Wróć',
    'menu.quitTutorial': 'Zakończ samouczek',
    'menu.open': 'Menu',
};

export default menuPl;
